// Question constants
export const QUESTION_UPDATED = "QUESTION_UPDATED";

// Template constants
export const SHOW_TEXT_BUTTON_CLICKED = "SHOW_TEXT_BUTTON_CLICKED";